const richTextStyleClassMap: Record<string, Record<string, string>> = {
	'text-align': {
		center: 'text-center',
		right: 'text-end',
		end: 'text-end',
		left: 'text-start',
		start: 'text-start',
	},
};

const richTextMappableTags: string[] = ['p', 'div', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

export function mapRichTextInlineStylesToClasses(html: string): string {
	return html.replace(
		new RegExp(`<(${richTextMappableTags.join('|')})\\b([^>]*?)\\sstyle=(['"])([^'"]*)\\3([^>]*)>`, 'gi'),
		(
			_fullMatch,
			tagName: string,
			beforeStyle: string,
			_quote: string,
			styleValue: string,
			afterStyle: string
		) => {
			const {remainingStyle, mappedClasses} = mapInlineStylesToClasses(styleValue);
			if (mappedClasses.length === 0) {
				return `<${tagName}${beforeStyle} style="${styleValue}"${afterStyle}>`;
			}

			const styleAttribute = remainingStyle ? ` style="${remainingStyle}"` : '';
			const remainingAttributes = `${beforeStyle}${afterStyle}`;
			const classMatch = remainingAttributes.match(/\sclass=(['"])([^'"]*)\1/i);

			if (!classMatch) {
				return `<${tagName}${remainingAttributes}${styleAttribute} class="${mappedClasses.join(' ')}">`;
			}

			const currentClasses = classMatch[2].split(/\s+/).filter(Boolean);
			const mergedClasses = [...new Set([...currentClasses, ...mappedClasses])];
			const updatedAttributes = remainingAttributes.replace(/\sclass=(['"])([^'"]*)\1/i, ` class="${mergedClasses.join(' ')}"`);
			return `<${tagName}${updatedAttributes}${styleAttribute}>`;
		}
	);
}

function mapInlineStylesToClasses(styleValue: string): {remainingStyle: string; mappedClasses: string[]} {
	const mappedClasses: string[] = [];
	const remainingStyles = styleValue
		.split(';')
		.map((part) => part.trim())
		.filter(Boolean)
		.filter((part) => {
			const [rawProperty, ...rawValueParts] = part.split(':');
			if (!rawProperty || rawValueParts.length === 0) {
				return true;
			}

			const property = rawProperty.trim().toLowerCase();
			const value = rawValueParts.join(':').trim().toLowerCase();
			const mappedClass = richTextStyleClassMap[property]?.[value];
			if (!mappedClass) {
				return true;
			}

			mappedClasses.push(mappedClass);
			return false;
		});

	return {
		remainingStyle: remainingStyles.join('; '),
		mappedClasses,
	};
}
